import { NgModule } from '@angular/core';
import { AnimationComponent } from './animation.component';



@NgModule({
  declarations: [AnimationComponent],
  imports: [
  ],
  exports: [AnimationComponent]
})
export class AnimationModule { }
